import { useEffect, useState } from "react";
import { TELEFON_ABFRAGE } from "../me/index.js";
/** Grober Zeiger (Touch) — v006 behandelt ihn wie das Telefon (Tippen statt Überfahren, Trefferfläche `--treffer`). */
export const GROBER_ZEIGER = "(pointer: coarse)";
/**
 * Ob eine Medienabfrage gerade zutrifft; folgt dem Drehen und dem Ziehen des Fensters. Ohne `matchMedia` (alte
 * WebViews) gilt: trifft nicht zu.
 */
export function useMedienabfrage(abfrage) {
    const liste = () => typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(abfrage) : null;
    const [trifft, setTrifft] = useState(() => liste()?.matches ?? false);
    useEffect(() => {
        const l = liste();
        if (l === null)
            return undefined;
        const beiWechsel = () => setTrifft(l.matches);
        beiWechsel();
        l.addEventListener("change", beiWechsel);
        return () => l.removeEventListener("change", beiWechsel);
    }, [abfrage]);
    return trifft;
}
/**
 * Ob das Fenster gerade ein TELEFON ist — dieselbe Medienabfrage wie in me-design
 * (`TELEFON_ABFRAGE`, max-width 743px; Story „Tabelle › Bearbeitungstabelle“).
 *
 * Entscheid 42 (Dirk 17.10.2026): Bearbeitungstabellen bearbeiten ab Tablet direkt in der
 * Zeile; am Telefon stehen die Zeilen nur lesend, „Bearbeiten“ öffnet einen Dialog.
 */
export function useTelefon() {
    return useMedienabfrage(TELEFON_ABFRAGE);
}
//# sourceMappingURL=useTelefon.js.map